//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import buttonBase from './_buttonBase';
/* istanbul ignore next dynamic imports */

var revealModal = function revealModal() {
  return import(
  /* webpackChunkName: 'revealModal' */
  '../Modals/revealModal');
};

export default {
  extends: buttonBase,
  data: function data() {
    return {
      modalComponent: '',
      modalSettings: {},
      isModalVisible: false,
      displayName: this.button ? this.button.displayName : ''
    };
  },
  components: {
    'revealModal': revealModal
  },
  watch: {
    button: function button() {
      this.displayName = this.button ? this.button.displayName : '';
    }
  },
  methods: {
    performAction: function performAction(event) {
      if (this.$_checkForprivacyOptOut(this.button) == true) {
        return;
      }

      event.stopPropagation(); // if already open, close the modal on click

      if (this.isModalVisible) {
        this.isModalVisible = false;
        return true;
      }

      var settings = {
        buttons: this.button ? this.button.nestedButtons : [],
        toolbarName: this.toolbarName || '',
        pageAttributes: this.pageAttributes || {},
        userSettings: this.userSettings || {},
        recaptchaPublicKey: this.recaptchaPublicKey || ''
      };
      this.showModal(settings);
      this.$_raiseAnalyticsEvent('ShareMenuClick');
      return true;
    },
    showModal: function showModal(settings) {
      this.modalComponent = 'revealModal';
      this.modalSettings = settings;
      this.isModalVisible = true;
    },
    hideModal: function hideModal(event) {
      this.isModalVisible = false;
      event.stopPropagation();
    }
  }
};